import { Divider } from '@mui/material'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { ActionButton, AlertSpan } from '../common/CommonStyled'
import ModalSelectType from './ModalSelectType'
import InputBoxOnChange from '../inputbox/InputBoxOnChange'
import { ModalAdSheduleAddStore } from 'src/stores/ModalStore'
import AddEtc from './AddEtc'
import DateRangePickerAdR_Recruit from './DateRangePickerAdR_Recruit'
import DatePickerAdR_StartJob from './DatePickerAdR_StartJob'
import DatePickerAdR_EndJob from './DatePickerAdR_EndJob'
import EtcElement from './EtcElement'
import AddIcon from '@mui/icons-material/Add';
import { Icon_Link } from '../common/CommonIcons'

const PageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 24px;

    position: relative;
    margin-top: 24px;
    overflow-y: auto;
    max-height: 80vh;
`
const LabelWarpper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 720px;
  position:relative;
`

const LabelSpan = styled.div`
  flex: 1;
  font-size: 18px;
  font-weight: 600;
`

const ElementWrapper = styled.div`
  width: 512px;
`
const ElementContainerA = styled.a`
  display: flex;
  align-items:center;
  gap: 10px;

  /* text-decoration: underline; */
  color: #0F172A;
  padding: 8px 10px;
  max-height: 40px;
  box-sizing: border-box;
`
const ElementSpan = styled.span`
  flex: 1; /* 핵심 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const CircleWrapper = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
  });

const Circle = styled.div<{ isNow?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${({ isNow }) => (isNow ? '#FFF' : '#508A9C')};
  border: 2px solid #A7C5CD;
  filter: ${({ isNow }) =>
    isNow ? 'drop-shadow(0px 0px 4px rgba(49, 242, 189, 0.8))' : 'none'};
  z-index: 2;
  color: white;
  font-size: 12px;
`;

const Line = styled.div`
  position: absolute;
  height: 56px;
  background-color: #A7C5CD;
  flex-grow: 1;
  margin-top: 0px; // 바로 이어붙이기
  top: 8px;
  border: 1px solid #A7C5CD;
  z-index: -1;
`;

const ModalContentScheduleDetail = () => {
  const returnData = ModalAdSheduleAddStore((state)=>state.returnData)
  const title = ModalAdSheduleAddStore((state)=>state.title)
  const setField = ModalAdSheduleAddStore((state)=>state.setField)
  const certification = ModalAdSheduleAddStore((state)=>state.certification)
  const urlLink = ModalAdSheduleAddStore((state)=>state.urlLink)
  const reset = ModalAdSheduleAddStore((state)=>state.reset)
  const etc = ModalAdSheduleAddStore((state)=>state.etc)
  const ismodify = ModalAdSheduleAddStore((state)=>state.ismodify)

  const [isAdd,setIsAdd] = useState(false)
  const [tempTitle,setTempTitle] = useState<string|undefined>('')
  const [tempType,setTempType] = useState<string|undefined>('')
  const [tempCertification,setTempCertification] = useState<string|undefined>('')
  const [tempUrl,setTempUrl] = useState<string|undefined>('')
  const [tempEtc,setTempEtc] = useState<any>([])
  useEffect(()=>{
    return(()=>{
      reset()
    })
  },[])

  useEffect(()=>{
    setField('type',returnData?.recruitment_type)
    setField('title',returnData?.title)
    setField('certification',returnData?.requirements)
    setField('urlLink',returnData?.source_url)
    setField('recruitestartdate',returnData?.application_sdate)
    setField('recruiteenddate',returnData?.application_edate)
    setField('etc',returnData?.schedules)
    setField('startjob',returnData?.enlistment_date)
    setField('endjob',returnData?.appointment_date)

    setTempTitle(returnData?.title)
    setTempCertification(returnData?.requirements)
    setTempUrl(returnData?.source_url)
    setTempType(returnData?.recruitment_type)
    setTempEtc(returnData?.schedules)
    
  },[returnData])

  useEffect(()=>{
    setField('title',tempTitle)
    setField('certification',tempCertification)
    setField('urlLink',tempUrl)
    setField('type',tempType)
    if(tempEtc.length !== 0){
      setField('etc',tempEtc)
    }
  },[ismodify])

  const ensureUrlProtocol = (url: string) => {
  if (!/^https?:\/\//i.test(url)) {
    return `https://${url}`;
  }
  return url;
};

  return (
    <>
    <PageWrapper>
      <LabelWarpper>
        <LabelSpan>선발유형</LabelSpan>
        <ElementWrapper>{ismodify ? <ModalSelectType/>: tempType}</ElementWrapper>
      </LabelWarpper>
      <LabelWarpper>
        <LabelSpan>공고명</LabelSpan>
        <ElementWrapper>
          {ismodify ? (
            <>
            <InputBoxOnChange value={title} onChange={(e)=>setField('title',e.target.value)} height='40px'/> 
            {!title && <AlertSpan $isValid={false}>공고 명을 입력해주세요</AlertSpan>}
            </>)
          : 
          tempTitle}
        </ElementWrapper>
      </LabelWarpper>
      <LabelWarpper>
        <LabelSpan>지원자격</LabelSpan>
        <ElementWrapper>{ismodify ? <InputBoxOnChange value={certification} onChange={(e)=>setField('certification',e.target.value)} height='40px'/>: tempCertification}</ElementWrapper>
      </LabelWarpper>
      <LabelWarpper>
        <LabelSpan>공고 URL</LabelSpan>
        <ElementWrapper style={{backgroundColor:'#EEF6F8'}}>
          {ismodify ? 
          <InputBoxOnChange value={urlLink} onChange={(e)=>setField('urlLink',e.target.value)} height='40px'/>
          : 
          <ElementContainerA href={ensureUrlProtocol(urlLink)} target='blank' rel="noopener noreferrer">
          <Icon_Link /> 
          <ElementSpan>{tempUrl}</ElementSpan>
          </ElementContainerA>}
        </ElementWrapper>
      </LabelWarpper>
      <Divider sx={{width:'100%', borderColor:'#D1D1D1'}}/>
      { ismodify ?
        <LabelWarpper>
          <LabelSpan></LabelSpan>
          <ElementWrapper>
            { isAdd ? 
                <AddEtc title='과정 추가' set_isAdd={setIsAdd}/> 
                : 
                <ActionButton style={{width:'100%', height:'40px'}} onClick={()=>setIsAdd(true)}>
                  <div style={{display:'flex',justifyContent:'center', alignItems:'center', gap:'10px'}}>
                    <AddIcon/>과정추가
                  </div>
                </ActionButton>
            }
          </ElementWrapper>
        </LabelWarpper> 
        :
        <></>
      }
      <LabelWarpper>
        <div style={{position:'absolute', left:'-32px'}}>
          <CircleWrapper>
            <Circle>
              1
            </Circle>
            <Line />
          </CircleWrapper>
        </div>
        <LabelSpan>
          <span style={{color:'#09A7D6'}}>*</span>
          <span> 접수기간</span>
        </LabelSpan>
        <ElementWrapper>
          <div style={{width: '100%', height:'40px', pointerEvents: ismodify ? 'auto':'none'}}>
            <DateRangePickerAdR_Recruit textAlign='center'/>
          </div>
        </ElementWrapper>
      </LabelWarpper>
      {etc.length !==0 &&
        etc.map((item, index) => (
          <EtcElement item={item} index={index} isReturn={true} is_Modify={ismodify}/>
        ))}
      <LabelWarpper>
        <div style={{position:'absolute', left:'-32px'}}>
          <CircleWrapper>
            <Circle>
              {etc.length+2}
            </Circle>
            <Line />
          </CircleWrapper>
        </div>
        <LabelSpan>
          <span style={{color:'#09A7D6'}}>*</span>
          <span> 입영일</span>
        </LabelSpan>
        <ElementWrapper>          
          <div style={{width: '100%', height:'40px', pointerEvents: ismodify ? 'auto':'none'}}>
            <DatePickerAdR_StartJob textAlign='center'/>
          </div>
        </ElementWrapper>
      </LabelWarpper>
      <LabelWarpper>
        <div style={{position:'absolute', left:'-32px'}}>
          <CircleWrapper>
            <Circle>
              {etc.length+3}
            </Circle>
            {/* <Line /> */}
          </CircleWrapper>
        </div>
        <LabelSpan>
          <span style={{color:'#09A7D6'}}>*</span>
          <span> 임관일</span>
        </LabelSpan>
        <ElementWrapper>          
          <div style={{width: '100%', height:'40px', pointerEvents: ismodify ? 'auto':'none'}}>
            <DatePickerAdR_EndJob textAlign='center'/>
          </div>
        </ElementWrapper>
      </LabelWarpper>
    </PageWrapper>
    </>
  )
}

export default ModalContentScheduleDetail